/* eslint-disable global-require */
import React from 'react';

import Head from 'next/head';

import Article from '../../Components/Article';
// import AgentTab from './Fragments/AgentTab';
import LearnMore from '../../Components/LearnMore';
import Navbar from '../../Components/Navbar';
import WantToLearnMore from '../../Components/WantToLearnMore';
import Footer from '../../Components/Footer';
import DigitalDisplay from '../../Components/DigitalDisplay';
import FeaturedContent from '../../Components/FeaturedContent';
import Button from '../../Components/Button';

class About extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <title key="title">EDvice</title>
          <meta content="EDvice" key="og:title" property="og:title" />
          <meta content="EDvice" key="description" name="description" />
          <meta content="EDvice" key="og:description" property="og:description" />
        </Head>

        <Navbar>Navbar</Navbar>
        <div className="feature">
          <DigitalDisplay right color="red" image={require('./image1.jpg')}>
            <Article>
              <header className="about__header" id="about">
                <h3>
                  <span>
                    <strong>Our Partners</strong>
                  </span>
                </h3>
              </header>
            </Article>
          </DigitalDisplay>
        </div>

        <FeaturedContent
          color="red"
          image={require('./image2.png')}
          link="https://www.18fifty3.com.au/"
          // test
          // image1={require('./1.png')}
          // image2={require('./2.png')}
          // image3={require('./3.png')}
        >
          <Article>
            <header className="article__header" id="exams">
              <h2>TestEd English</h2>
            </header>
            <section className="article__section">
              <p>
                TestEd English is an Authorised Linguaskill Agent for Cambridge Assessment English,
                part of the University of Cambridge. Through Cambridge Assessment English they offer
                the world’s leading range of qualifications and tests for learners and teachers of
                English, globally recognised by more than 20,000 leading universities, employers and
                governments.
                <br />
                <br />
                EDvice has partnered with TestEd English to deliver English Language testing
                solutions throughout Australia. EDvice is TestEd English’s exclusive Supply Nation
                registered reseller of Linguaskill in Australia.
              </p>
            </section>
            <footer className="article__footer">
              <Button as="link" color="red" basic onClick={() => 'https://testedenglish.com/'}>
                More information
              </Button>
            </footer>
          </Article>
        </FeaturedContent>

        <FeaturedContent
          right
          sponsor
          color="red"
          link="https://www.18fifty3.com.au/"
          image={require('./image3.png')}
        >
          <Article>
            <header className="article__header">
              <h2>18fifty3 Group</h2>
            </header>
            <section className="article__section">
              <p>
                18FiFTY3 Group is a Indigenous owned and incorporated company with its head office
                in the ACT. The company is a Certified Supply Nation Indigenous organisation.
                <br />
                <br />
                Our purposes is to build trusted relationships with customers, provide sustainable
                outcomes on projects and build strategic partnerships providing better outcomes for
                their clients, team members and the community.
                <br />
                <br />
                The company operates across a range of fields including facilities and asset
                management, aviation/aerospace, marketing and education/training. 18Fifty3 Group
                prides itself on giving back to community and their IND-SPIRE programs are based on
                supporting Indigenous youth in STEM education programs and inspiring indigenous
                youth to stay in education and technical jobs.
                <br />
                <br />
                The company is well established operating throughout the ACT, Northern Territory,
                New South Wales and across Eastern Australia.
              </p>
            </section>
            <footer className="article__footer">
              <Button as="link" color="red" basic onClick={() => 'https://www.18fifty3.com.au/'}>
                More information
              </Button>
            </footer>
          </Article>
        </FeaturedContent>

        <FeaturedContent
          color="red"
          link="https://pcfoundation.org.au/"
          image={require('./image4.png')}
        >
          <Article>
            <header className="article__header" id="exams">
              <h2>The Preston Campbell Foundation</h2>
            </header>
            <section className="article__section">
              <p>
                The Preston Campbell Foundation partners with EDvice to ensure the indigenous
                training and programs being delivered meet community expectations, provide mentoring
                and leadership programs and help in marketing the training and opportunities to
                community members.
                <br />
                <br />
                Established in 2016, the Preston Campbell Foundation is an endeavour of passion by
                Preston Campbell and the team he inspires.
                <br />
                <br />
                The foundation supports Preston’s vision of developing programs and opportunities,
                which inspire and mentor participants to achieve their aspirations and dreams.
                Accomplished by connecting Aboriginal and Torres Strait Islander peoples with their
                culture, sense of place and well being.
                <br />
                <br />
                Preston shares his journey with individuals, families and communities through a
                variety of learning forums to inspire all of us to ‘live above the line’.
              </p>
            </section>
            <footer className="article__footer">
              <Button as="link" color="red" basic onClick={() => 'https://pcfoundation.org.au/'}>
                More information
              </Button>
            </footer>
          </Article>
        </FeaturedContent>

        <LearnMore />
        <WantToLearnMore />
        <Footer />
      </React.Fragment>
    );
  }
}
export default About;
